import {
  VIRTUAL_SCROLL_GRID_ID,
  VIRTUAL_SCROLL_GRID_SCROLL_DELAY,
  VIRTUAL_SCROLL_GRID_SCROLL_OFFSET,
} from '../constants';

/**
 * Scrolls to the top of the grid element.
 * @param {Object} params - The parameters object.
 * @param {boolean} [params.isMobile=false] - Whether the device is mobile. Defaults to false.
 * @param {string} [params.gridElementId=VIRTUAL_SCROLL_GRID_ID] - The ID of the grid element. Defaults to VIRTUAL_SCROLL_GRID_ID.
 * @param {number} [params.yOffset=VIRTUAL_SCROLL_GRID_SCROLL_OFFSET] - The vertical offset to apply when scrolling. Defaults to VIRTUAL_SCROLL_GRID_SCROLL_OFFSET.
 * @param {number} [params.delay=VIRTUAL_SCROLL_GRID_SCROLL_DELAY] - The delay before scrolling in milliseconds. Defaults to VIRTUAL_SCROLL_GRID_SCROLL_DELAY.
 * @returns {void}
 */
export const scrollToTopOfGrid = ({
  isMobile = false,
  gridElementId = VIRTUAL_SCROLL_GRID_ID,
  yOffset = VIRTUAL_SCROLL_GRID_SCROLL_OFFSET,
  delay = VIRTUAL_SCROLL_GRID_SCROLL_DELAY,
}) => {
  if (isMobile) {
    return;
  }

  const gridElement = document.getElementById(gridElementId);
  if (gridElement) {
    const y =
      gridElement.getBoundingClientRect().top + window.scrollY + yOffset;

    // Delay the scroll to allow for any layout changes
    setTimeout(() => {
      window.scrollTo({ top: y, behavior: 'smooth' });
    }, delay);
  }
};
